module.exports = __webpack_public_path__ + "static/media/TB-303--mobile.7fa476ee.svg";